// extracted by mini-css-extract-plugin
export default {"tabsContainer":"ProgressBar_tabsContainer__R8wjx"};